export const products = [
  {
    id: 1,
    name: "Men's Printed Casual Shirt",
    price: 1200,
    image: "https://myraymond.com/cdn/shop/files/CMSS30070-G5-1.jpg",
    discount: 10,
    rating: 4.5,
    category: "Shirts",
    brand: "Raymond",
    description: "A stylish printed casual shirt crafted for everyday comfort. Features a relaxed fit with premium cotton fabric and a subtle modern print that pairs easily with trousers or jeans.",
  },
      {
    id: 31,
    name: "Argentina Jersey",
    price: 2000,
    image: "https://www.jdsports.my/cdn/shop/files/jd_JN3708_a.jpg",//"https://images.footballfanatics.com/argentina-national-team/argentina-adidas-home-shirt-2026-messi-number-10_ss5_p-203495754+pv-1+u-su78lmafwq7388xi9yst+v-mmtndbgje3ufuzlh84ju.jpg",
    discount: 50,
    rating: 5.00,
    category: "TShirts",
    brand: "Concord",
    description: "A stylish printed casual tshirt crafted for everyday comfort. Features a relaxed fit with premium cotton fabric and a subtle modern print that pairs easily with trousers or jeans.",
  },
    {
    id: 32,
    name: "Argentina Jersey",
    price: 2100,
    image: "https://i.ibb.co.com/N25crkMn/argentina-jearsy2.webp",//"https://images.footballfanatics.com/argentina-national-team/argentina-adidas-home-shirt-2026-messi-number-10_ss5_p-203495754+pv-1+u-su78lmafwq7388xi9yst+v-mmtndbgje3ufuzlh84ju.jpg",
    discount: 40,
    rating: 5.00,
    category: "TShirts",
    brand: "Concord",
    description: "A stylish printed casual tshirt crafted for everyday comfort. Features a relaxed fit with premium cotton fabric and a subtle modern print that pairs easily with trousers or jeans.",
  },
      {
    id: 33,
    name: "Argentina Jersey",
    price: 2500,
    image: "https://i.ibb.co.com/n88F9nXL/argentina-jearsy3.webp",//"https://images.footballfanatics.com/argentina-national-team/argentina-adidas-home-shirt-2026-messi-number-10_ss5_p-203495754+pv-1+u-su78lmafwq7388xi9yst+v-mmtndbgje3ufuzlh84ju.jpg",
    discount: 30,
    rating: 5.00,
    category: "TShirts",
    brand: "Concord",
    description: "A stylish printed casual tshirt crafted for everyday comfort. Features a relaxed fit with premium cotton fabric and a subtle modern print that pairs easily with trousers or jeans.",
  },
     {
    id: 34,
    name: "Brazil Jersey",
    price: 1900,
    image: "https://i.ibb.co.com/G30FkjR8/brazil-jearsy-01.webp",//"https://images.footballfanatics.com/argentina-national-team/argentina-adidas-home-shirt-2026-messi-number-10_ss5_p-203495754+pv-1+u-su78lmafwq7388xi9yst+v-mmtndbgje3ufuzlh84ju.jpg",
    discount: 30,
    rating: 5.00,
    category: "TShirts",
    brand: "Concord",
    description: "A stylish printed casual tshirt crafted for everyday comfort. Features a relaxed fit with premium cotton fabric and a subtle modern print that pairs easily with trousers or jeans.",
  },
       {
    id: 35,
    name: "Brazil Jersey",
    price: 1800,
    image: "https://i.ibb.co.com/WNTrxFxF/brazil-jearsy-02.webp",//"https://images.footballfanatics.com/argentina-national-team/argentina-adidas-home-shirt-2026-messi-number-10_ss5_p-203495754+pv-1+u-su78lmafwq7388xi9yst+v-mmtndbgje3ufuzlh84ju.jpg",
    discount: 30,
    rating: 5.00,
    category: "TShirts",
    brand: "Concord",
    description: "A stylish printed casual tshirt crafted for everyday comfort. Features a relaxed fit with premium cotton fabric and a subtle modern print that pairs easily with trousers or jeans.",
  },
         {
    id: 36,
    name: "Brazil Kids Jersey",
    price: 1800,
    image: "https://i.ibb.co.com/GftT80sz/Brazil-Kids-03.webp",//"https://images.footballfanatics.com/argentina-national-team/argentina-adidas-home-shirt-2026-messi-number-10_ss5_p-203495754+pv-1+u-su78lmafwq7388xi9yst+v-mmtndbgje3ufuzlh84ju.jpg",
    discount: 30,
    rating: 5.00,
    category: "TShirts",
    brand: "Concord",
    description: "A stylish printed casual tshirt crafted for everyday comfort. Features a relaxed fit with premium cotton fabric and a subtle modern print that pairs easily with trousers or jeans.",
  },
         {
    id: 37,
    name: "Spain Jersey",
    price: 1800,
    image: "https://i.ibb.co.com/6RpyYqKz/spain-jearsy-01.webp",//"https://images.footballfanatics.com/argentina-national-team/argentina-adidas-home-shirt-2026-messi-number-10_ss5_p-203495754+pv-1+u-su78lmafwq7388xi9yst+v-mmtndbgje3ufuzlh84ju.jpg",
    discount: 30,
    rating: 5.00,
    category: "TShirts",
    brand: "Concord",
    description: "A stylish printed casual tshirt crafted for everyday comfort. Features a relaxed fit with premium cotton fabric and a subtle modern print that pairs easily with trousers or jeans.",
  },
         {
    id: 38,
    name: "Spain Jersey",
    price: 1800,
    image: "https://i.ibb.co.com/bgyDVPTM/spain-jearsy-02.jpg",//"https://images.footballfanatics.com/argentina-national-team/argentina-adidas-home-shirt-2026-messi-number-10_ss5_p-203495754+pv-1+u-su78lmafwq7388xi9yst+v-mmtndbgje3ufuzlh84ju.jpg",
    discount: 30,
    rating: 5.00,
    category: "TShirts",
    brand: "Concord",
    description: "A stylish printed casual tshirt crafted for everyday comfort. Features a relaxed fit with premium cotton fabric and a subtle modern print that pairs easily with trousers or jeans.",
  },
         {
    id: 39,
    name: "Spain Jersey",
    price: 1800,
    image: "https://i.ibb.co.com/PGpw1hP6/spain-jearsy-03.jpg",//"https://images.footballfanatics.com/argentina-national-team/argentina-adidas-home-shirt-2026-messi-number-10_ss5_p-203495754+pv-1+u-su78lmafwq7388xi9yst+v-mmtndbgje3ufuzlh84ju.jpg",
    discount: 30,
    rating: 5.00,
    category: "TShirts",
    brand: "Concord",
    description: "A stylish printed casual tshirt crafted for everyday comfort. Features a relaxed fit with premium cotton fabric and a subtle modern print that pairs easily with trousers or jeans.",
  },{
    id: 410,
    name: "Agrentina Women Jersey",
    price: 1800,
    image: "https://i.ibb.co.com/rfQbnCtn/argentina-women-jearcy-05.jpg",//"https://images.footballfanatics.com/argentina-national-team/argentina-adidas-home-shirt-2026-messi-number-10_ss5_p-203495754+pv-1+u-su78lmafwq7388xi9yst+v-mmtndbgje3ufuzlh84ju.jpg",
    discount: 30,
    rating: 5.00,
    category: "TShirts",
    brand: "Concord",
    description: "A stylish printed casual tshirt crafted for everyday comfort. Features a relaxed fit with premium cotton fabric and a subtle modern print that pairs easily with trousers or jeans.",
  },
         {
    id: 40,
    name: "Agrentina Women Jersey",
    price: 1800,
    image: "https://i.ibb.co.com/LD61Zj8T/argentina-jearcy-04.webp",//"https://images.footballfanatics.com/argentina-national-team/argentina-adidas-home-shirt-2026-messi-number-10_ss5_p-203495754+pv-1+u-su78lmafwq7388xi9yst+v-mmtndbgje3ufuzlh84ju.jpg",
    discount: 30,
    rating: 5.00,
    category: "TShirts",
    brand: "Concord",
    description: "A stylish printed casual tshirt crafted for everyday comfort. Features a relaxed fit with premium cotton fabric and a subtle modern print that pairs easily with trousers or jeans.",
  },
           {
    id: 41,
    name: "France Jersey",
    price: 1800,
    image: "https://i.ibb.co.com/6RRK80jN/france-jearcy-01.jpg",//"https://images.footballfanatics.com/argentina-national-team/argentina-adidas-home-shirt-2026-messi-number-10_ss5_p-203495754+pv-1+u-su78lmafwq7388xi9yst+v-mmtndbgje3ufuzlh84ju.jpg",
    discount: 30,
    rating: 5.00,
    category: "TShirts",
    brand: "Concord",
    description: "A stylish printed casual tshirt crafted for everyday comfort. Features a relaxed fit with premium cotton fabric and a subtle modern print that pairs easily with trousers or jeans.",
  },
           {
    id: 42,
    name: "Germany Jersey",
    price: 1800,
    image: "https://i.ibb.co.com/S7n2HLFz/germany-jearcy-01.webp",//"https://images.footballfanatics.com/argentina-national-team/argentina-adidas-home-shirt-2026-messi-number-10_ss5_p-203495754+pv-1+u-su78lmafwq7388xi9yst+v-mmtndbgje3ufuzlh84ju.jpg",
    discount: 30,
    rating: 5.00,
    category: "TShirts",
    brand: "Concord",
    description: "A stylish printed casual tshirt crafted for everyday comfort. Features a relaxed fit with premium cotton fabric and a subtle modern print that pairs easily with trousers or jeans.",
  },
           {
    id: 43,
    name: "Germany Jersey",
    price: 1800,
    image: "https://i.ibb.co.com/HLbXgc5s/germany-jearcy-02.webp",//"https://images.footballfanatics.com/argentina-national-team/argentina-adidas-home-shirt-2026-messi-number-10_ss5_p-203495754+pv-1+u-su78lmafwq7388xi9yst+v-mmtndbgje3ufuzlh84ju.jpg",
    discount: 30,
    rating: 5.00,
    category: "TShirts",
    brand: "Concord",
    description: "A stylish printed casual tshirt crafted for everyday comfort. Features a relaxed fit with premium cotton fabric and a subtle modern print that pairs easily with trousers or jeans.",
  },
           {
    id: 44,
    name: "Portugal Jersey",
    price: 1700,
    image: "https://i.ibb.co.com/JjdJ9qpS/portugal-jearcy-01.jpg",//"https://images.footballfanatics.com/argentina-national-team/argentina-adidas-home-shirt-2026-messi-number-10_ss5_p-203495754+pv-1+u-su78lmafwq7388xi9yst+v-mmtndbgje3ufuzlh84ju.jpg",
    discount: 30,
    rating: 5.00,
    category: "TShirts",
    brand: "Concord",
    description: "A stylish printed casual tshirt crafted for everyday comfort. Features a relaxed fit with premium cotton fabric and a subtle modern print that pairs easily with trousers or jeans.",
  },
           {
    id: 45,
    name: "Portugal Jersey",
    price: 1800,
    image: "https://i.ibb.co.com/Q5P6TVT/portugal-jearcy-02.jpg",//"https://images.footballfanatics.com/argentina-national-team/argentina-adidas-home-shirt-2026-messi-number-10_ss5_p-203495754+pv-1+u-su78lmafwq7388xi9yst+v-mmtndbgje3ufuzlh84ju.jpg",
    discount: 30,
    rating: 5.00,
    category: "TShirts",
    brand: "Concord",
    description: "A stylish printed casual tshirt crafted for everyday comfort. Features a relaxed fit with premium cotton fabric and a subtle modern print that pairs easily with trousers or jeans.",
  },

  {
    id: 2,
    name: "Carston Sweater Polo",
    price: 19700,
    image: "https://velvet-tees.com/cdn/shop/files/cotton-knits-carston02-asteroid_01120.jpg",
    discount: 15,
    rating: 4.5,
    category: "Polo",
    brand: "Velvet",
    description: "Luxurious cotton-knit sweater polo combining sophistication with everyday comfort. The structured ribbed collar and clean finish make it perfect for smart-casual occasions.",
  },
  {
    id: 3,
    name: "Beck Linen Cotton Polo",
    price: 6200,
    image: "https://velvet-tees.com/cdn/shop/files/linen-cot-jers-beck02-caspian_4898.jpg",
    discount: 10,
    rating: 4.5,
    category: "Polo",
    brand: "Velvet",
    description: "Breathable linen-cotton jersey polo in a refreshing caspian blue hue. Ideal for warm-weather outings, this polo offers natural texture and a cool, laid-back silhouette.",
  },
  {
    id: 4,
    name: "Levinson Linen Cotton Tee",
    price: 1000,
    image: "https://velvet-tees.com/cdn/shop/files/linen-cotton-jersey-levinson02-zinc_0007.jpg",
    discount: 15,
    rating: 4.5,
    category: "T-Shirts",
    brand: "Velvet",
    description: "Lightweight linen-cotton blend tee in understated zinc. A perfect summer staple offering natural breathability and easy wear for sun-drenched days.",
  },
  {
    id: 5,
    name: "Rodan Luxe Fleece Hoodie",
    price: 201000,
    image: "https://velvet-tees.com/cdn/shop/files/luxe-fleece-rodan01-dragon_05711.jpg",
    discount: 15,
    rating: 4.5,
    category: "Hoodies",
    brand: "Velvet",
    description: "Premium luxe fleece hoodie in a bold dragon red. The ultra-soft brushed interior and relaxed silhouette make it the ultimate cozy layer for cooler evenings.",
  },
  {
    id: 6,
    name: "Wells Midweight Jersey Tee",
    price: 4700,
    image: "https://velvet-tees.com/cdn/shop/files/midweight-jersey-wells02-zinc_0008.jpg",
    discount: 5,
    rating: 4.5,
    category: "T-Shirts",
    brand: "Velvet",
    description: "Classic midweight jersey tee with a perfect structured drape. The versatile zinc colorway pairs effortlessly with any outfit, from joggers to chinos.",
  },
  {
    id: 7,
    name: "Abstract Lion Oversized T-Shirt",
    price: 2000,
    image: "https://peppythread.com/cdn/shop/files/2_Front_e763faa6-4a5a-45e7-8d4c-acce482d6dc7.png",
    discount: 7,
    rating: 4.5,
    category: "T-Shirts",
    brand: "Peppy Thread",
    description: "Unisex oversized t-shirt featuring a striking abstract lion face graphic. Relaxed casual wear with a bold statement look — great for streetwear enthusiasts.",
  },
  {
    id: 8,
    name: "Green Lyocell Nylon Kameez",
    price: 2800,
    image: "https://i.ibb.co.com/DPwz5v63/women-kamiz1.jpg",
    discount: 7,
    rating: 4.5,
    category: "Women's Wear",
    brand: "Taaga",
    description: "Elegant green mixed lyocell-nylon kameez with a flowing silhouette and refined finish. A beautiful choice for festive gatherings and everyday occasions alike.",
  },
  {
    id: 9,
    name: "Green Printed Lyocell Kameez",
    price: 2800,
    image: "https://i.ibb.co.com/r2jgnQQv/women-kamiz2.jpg",
    discount: 7,
    rating: 4.5,
    category: "Women's Wear",
    brand: "Taaga",
    description: "Graceful printed lyocell-nylon kameez in soft sage tones. Designed for the modern woman who values both cultural elegance and contemporary style.",
  },
  {
    id: 10,
    name: "Olive Striped Panjabi",
    price: 1800,
    image: "https://i.ibb.co.com/XfgDFwrP/panjabi1.webp",
    discount: 10,
    rating: 4.0,
    category: "Panjabi",
    brand: "Taaga Man",
    description: "Timeless striped olive panjabi with a refined cut. Made from fine-weave fabric for a crisp, polished appearance at traditional and semi-formal events.",
  },
  {
    id: 11,
    name: "Olive Cotton Linen Panjabi",
    price: 1800,
    image: "https://i.ibb.co.com/27ygj5Rs/panjabi2.webp",
    discount: 10,
    rating: 4.0,
    category: "Panjabi",
    brand: "Taaga Man",
    description: "Breathable cotton-linen blend panjabi in sophisticated olive. Lightweight and comfortable — ideal for warm-weather traditional wear with a modern touch.",
  },
  {
    id: 12,
    name: "Men's Coffee Casual Shirt",
    price: 1800,
    image: "https://twelvebd.com/cdn/shop/files/113504_16.jpg",
    discount: 10,
    rating: 4.0,
    category: "Shirts",
    brand: "Twelve BD",
    description: "Rich coffee-toned casual shirt with a modern tailored cut. A versatile everyday piece that transitions seamlessly from office hours to evening outings.",
  },
  {
    id: 13,
    name: "Black Cotton T-Shirt Embroidered",
    price: 5000,
    image: "https://elevennewyork.com/wp-content/uploads/2018/02/03_black-tee_model-front-scaled-scaled.jpg",
    discount: 12,
    rating: 4.2,
    category: "T-Shirts",
    brand: "Eleven New York",
    description: "Premium black cotton t-shirt with elegant embroidery detailing on the chest. Made from 100% organic cotton for all-day breathability and a clean, polished look.",
  },
  {
    id: 14,
    name: "Gray Cotton T-Shirt Embroidered",
    price: 1100,
    image: "https://elevennewyork.com/wp-content/uploads/2018/02/03_heather-tee_model-front-800x1100.jpg",
    discount: null,
    rating: 4.1,
    category: "T-Shirts",
    brand: "Eleven New York",
    description: "Classic heather gray t-shirt with subtle embroidered accents. A timeless wardrobe essential crafted from soft cotton for lasting comfort throughout the day.",
  },
  {
    id: 15,
    name: "Black Striped Cotton T-Shirt",
    price: 1100,
    image: "https://elevennewyork.com/wp-content/uploads/2018/02/03_blackstripe-tee_model-front-scaled-800x1100.jpg",
    discount: 10,
    rating: 4.5,
    category: "T-Shirts",
    brand: "Eleven New York",
    description: "Bold black-and-white striped t-shirt with a modern edge. Relaxed fit for effortless everyday styling — a versatile piece for both casual and semi-formal looks.",
  },
  {
    id: 16,
    name: "Black Striped Cotton Pant",
    price: 1200,
    image: "https://stridesco.sgp1.digitaloceanspaces.com/product/1725349658534-Strides_Model_19-8-240011 1.jpg",
    discount: 20,
    rating: 4.5,
    category: "Pant",
    brand: "Eleven New York",
    description: "Bold black-and-white striped t-shirt with a modern edge. Relaxed fit for effortless everyday styling — a versatile piece for both casual and semi-formal looks.",
  }
];
